import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const SimulationByValue = loadable(() => import('./SimulationByValue'), {});
export const SimulationByPeriod = loadable(() => import('./SimulationByPeriod'), {});
export const Summary = loadable(() => import('./Summary'), {});
export const SimulationSummary = Summary;
